import classnames from "classnames";
import React, { useCallback, useEffect, useState } from "react";

import { Button } from "../Common";

import "./index.scss";

interface InactionModalProps {
  heading: string;
  onClose: () => void;
  onSuccess: () => void;
  successBtnText?: string;
  cancelBtnText?: string;
}

const InactionModal = (props: InactionModalProps) => {
  const { onSuccess, successBtnText, onClose, cancelBtnText } = props;
  const [leftSeconds, setLeftSeconds] = useState(60);

  const decreaseTimer = useCallback(() => {
    setLeftSeconds((value) => value - 1);
  }, []);

  useEffect(() => {
    if (!leftSeconds) {
      onClose();
    }
  }, [leftSeconds, onClose]);

  useEffect(() => {
    const interval = setInterval(decreaseTimer, 1000);

    return () => clearInterval(interval);
  }, [decreaseTimer]);

  return (
    <div className={classnames("modal-content-wrapper inaction-modal")}>
      <div className="modal-heading">Are You Still Here?</div>
      <div className="modal-content">
        You will be returned to the Patient Management page in{" "}
        <div className="left-seconds">{leftSeconds} seconds.</div>
        <br />
        Would you like to stay connected?
      </div>
      <div className="modal-actions">
        <Button appearance="subtle" className="subtle auto-width" onClick={onClose}>
          {cancelBtnText || "I'm done"}
        </Button>
        <Button type="submit" className="blue auto-width" onClick={onSuccess}>
          {successBtnText || "Yes"}
        </Button>
      </div>
    </div>
  );
};
export default InactionModal;
